/* eslint-disable quotes */

// ---------- helpers ----------
const clone = (v) => JSON.parse(JSON.stringify(v ?? {}));

// ---------- langs ----------
/**
 * Build per-language object shape like:
 * {
 *   es: { lang: 'es', id: null, name: '' },
 *   en: { lang: 'en', id: null, name: '' }
 * }
 */
export function buildLangs(langs = []) {
  const o = {};
  langs.forEach(({ key }) => {
    o[key] = { id: null, lang: key, name: "" };
  });
  return o;
}

export function buildValidations() {
  return {
    name: "", // falta nombre en 1+ idiomas
  };
}

// ---------- ensure shape (UI) ----------
/**
 * Ensure minimal/default model shape for Supplement Benefits module.
 */
export function ensureShape(model = {}, langs = []) {
  const c = clone(model);

  // Core ids
  c.id = c.id ?? null;

  // Langs (object keyed by lang)
  c.langs = c.langs || buildLangs(langs);
  langs.forEach(({ key }) => {
    if (!c.langs[key]) {
      c.langs[key] = { id: null, lang: key, name: "" };
    }
    const l = c.langs[key];
    l.id = l.id ?? null;
    l.lang = key;
    l.name = l.name ?? "";
  });

  // Validations
  c.validations = c.validations || buildValidations();
  Object.keys(buildValidations()).forEach((k) => {
    c.validations[k] = c.validations[k] ?? "";
  });

  return c;
}

// ---------- format to API ----------
export function formatToSend(data = {}) {
  const editMode = !!data.id;

  // ----- LANGS -----
  const langsArray = Object.values(data.langs || {}).map((l) => ({
    id: l.id ?? null,
    lang: l.lang,
    value: l.name ?? "",
  }));

  // Generar el slug de name
  const spanishName = data.langs?.es?.name || data.langs?.en?.name || "";

  // ----- OUTPUT -----
  const out = {
    id: data.id ?? null,
    name: spanishName.trim(),
    langs: langsArray,
  };

  return [out, editMode];
}

// ---------- parse from API → UI ----------
export function parseFromApi(api = {}, langsConf = []) {
  const m = {
    id: api.id ?? null,

    // langs UI (obj)
    langs: buildLangs(langsConf),

    validations: buildValidations(),
  };
  console.log("api: ", api);

  // langs array → obj
  if (Array.isArray(api.langs)) {
    api.langs.forEach((l) => {
      if (!l || !l.lang) return;
      m.langs[l.lang] = {
        id: l.id ?? null,
        lang: l.lang,
        name: l.value ?? "",
      };
    });
  }

  return m;
}

/**
 * Valida y setea mensajes en model.validations.
 * Devuelve true si TODO es válido.
 */
export function validateBenefit(model, langs = [], { t = (k) => k } = {}) {
  // Reset
  model.validations = buildValidations();

  // --- 1) Por idioma: name (requerido)
  const missingName = [];

  langs.forEach(({ key }) => {
    const L = model.langs?.[key] || {};
    const nameVal = String(L.name ?? "");

    if (!nameVal.trim()) missingName.push(key);
  });

  if (missingName.length > 0) {
    const names = missingName.map((k) => t(`components.langs.${k}.name`)).join(", ");
    model.validations.name = `${t("views.alerts.form.title.validation")} (${names})`;
  }

  // --- helper sin-errores
  const isEmpty = (obj = {}) => Object.values(obj).every((v) => !v || String(v).trim() === "");
  return isEmpty(model.validations);
}
